const params = (new URL(document.location)).searchParams;
const videoId = params.get('videoId');
const dev = params.get('dev');
const staging = params.get('staging');

export { videoId, dev, staging };